module.exports = __webpack_public_path__ + "img/404.49b412d7.svg";